import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms-and-conditions-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-and-conditions-modal.html'
})
export class TermsAndConditionsModal {}
